import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { selectPermissions } from "../redux/permissionsSlice";

export default function UsePermissions() {
  const permissions = useSelector(selectPermissions);

  const memoizedPermissions = useMemo(() => permissions, [permissions]);

  const hasPermission = useCallback(
    (level, permission) => {
      if (!memoizedPermissions[level]) return false;
      return memoizedPermissions[level].includes(permission);
    },
    [memoizedPermissions]
  );

  const hasAllPermissionsChild1 = useMemo(() => {
    return hasPermission("CHILD1", "*");
  }, [hasPermission]);

  const hasAllBrandsViewChild1 = useMemo(() => {
    return hasPermission("CHILD1", "all.brands.view");
  }, [hasPermission]);

  const hasAllShopsViewChild1 = useMemo(() => {
    return hasPermission("CHILD1", "all.shops.view");
  }, [hasPermission]);

  return {
    hasPermission,
    hasAllPermissionsChild1,
    hasAllBrandsViewChild1,
    hasAllShopsViewChild1,
  };
}
